var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.4V8.91447M12.5 16.7248V16.7642M18.1699 20.5H6.83007C5.2811 20.5 3.97392 19.4763 3.56265 18.0757C3.38709 17.4778 3.60281 16.8551 3.93276 16.3249L9.60269 6.10102C10.9311 3.96632 14.0689 3.96633 15.3973 6.10103L18.2323 11.213L21.0672 16.3249C21.3972 16.8551 21.6129 17.4778 21.4373 18.0757C21.0261 19.4763 19.7189 20.5 18.1699 20.5Z",
    stroke: "#EB4325",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c0d15891ee7df9601c6f60cc5023b5bd.svg";
export { ForwardRef as ReactComponent };